import {
    AuthAction,
    FETCH_AUTH_DATA_FULFILLED,
    FETCH_AUTH_DATA_REJECTED,
    SET_APP_SETTINGS,
} from "./action-types";

export interface IAuthState {
    isLoading: boolean;
    isLoggedIn: boolean;
    languageTags: { [name: string]: string };
    appSettings: { [name: string]: any };
}

const initialState: IAuthState = {
    isLoading: true,
    isLoggedIn: false,
    languageTags: {},
    appSettings: {},
};

function authReducer(
    state: IAuthState = initialState,
    action: AuthAction
): IAuthState {
    switch (action.type) {
        case FETCH_AUTH_DATA_FULFILLED:
            return {
                ...state,
                isLoading: false,
                languageTags: action.payload.data.languageTags,
                appSettings: action.payload.data.appSettings,
            };

        case FETCH_AUTH_DATA_REJECTED:
            if (action.payload.response.data !== "AlreadyLoggedIn") {
                return state;
            }
            
            return {
                ...state,
                isLoggedIn: true,
            };

        case SET_APP_SETTINGS:
            return {
                ...state,
                appSettings: action.data,
            };

        default:
            return state;
    };
}

export default authReducer;
